import { createContext, useContext, useEffect, useState } from 'react'

import { getMarketCurrency, type Currency } from 'BrokerTsLib/src/enums'
import { AppSettings } from '../appSettings'
import type { IPartnerSettings } from '../appSettings/Partners'
import { getPartnerByHost } from '../appSettings/Partners'

export const PartnerContext = createContext<{
  currentPartner: IPartnerSettings | undefined
  setCurrentPartner: React.Dispatch<
    React.SetStateAction<IPartnerSettings | undefined>
  >
  getBaseUrl: () => string
  getAppUrl: () => string
  currency: Currency | undefined
}>({} as any)

export const PartnerContextProvider = (props: {
  children: React.ReactNode
}) => {
  const [currentPartner, setCurrentPartner] = useState(getPartnerByHost())

  // useState for store currency
  const [currency, setCurrency] = useState<Currency>()
  useEffect(() => {
    if (currentPartner) {
      setCurrency(getMarketCurrency(currentPartner.market))
    }
  }, [currentPartner])

  return (
    <PartnerContext.Provider
      value={{
        currentPartner: currentPartner,
        setCurrentPartner: setCurrentPartner,
        getBaseUrl: () => AppSettings.baseUrl,
        getAppUrl: () => window.location.origin + import.meta.env.VITE_BASE_URL,
        currency: currency,
      }}
    >
      {props.children}
    </PartnerContext.Provider>
  )
}

export const usePartner = () => {
  const context = useContext(PartnerContext)

  if (!context || context === undefined) {
    throw new Error('usePartner must be used within a PartnerContextProvider')
  }

  return context
}
